import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { calculateAverageRating, getVariantsPriceRange } from '../helpers';
export const setProductStructure = () => {
  return {
    details: null,
    hasVariants: false,
    variantDisplayName: '',
    variantsAvailable: [],
    variantSelected: null,
    variantPriceRange: [],
    shippingTime: null,
    reorderPossible: false,
    priceBrutto: null,
    stock: null,
    countSelected: null,
    personalization: null,
    ratingsCount: null,
    averageRating: null
  };
};
export const productReducer = (state, action) => {
  let localState = _objectSpread({}, state);
  switch (action.type) {
    case 'add':
      const product = action.payload;
      localState.details = product;
      localState.ratingsCount = product.ratings.length;
      localState.averageRating = calculateAverageRating(product.ratings);
      if (product.product_variants.length > 0) {
        localState.hasVariants = true;
        localState.variantsAvailable = product.product_variants;
        localState.variantPriceRange = getVariantsPriceRange(product.product_variants);
        localState.variantDisplayName = product.variant_display_name || 'Variante';
      } else {
        localState.priceBrutto = product.price_brutto;
        localState.countSelected = 1;
        localState.stock = product.stock;
        localState.shippingTime = product.shipping_time;
        localState.reorderPossible = product.reorder_possible ? true : !product.stock <= 0;
      }
      break;
    case 'reset':
      localState = setProductStructure();
      break;
    case 'variantChange':
      // Check if Object is empty "{}" to set variantSelected to null
      const isEmpty = Object.keys(action.payload).length === 0 && action.payload.constructor === Object;
      localState.variantSelected = isEmpty ? null : action.payload;
      if (!isEmpty) {
        localState.stock = action.payload.stock;
        localState.priceBrutto = action.payload.price_brutto;
        localState.countSelected = 1;
        localState.shippingTime = action.payload.shipping_time;
        localState.reorderPossible = action.payload.reorder_possible ? true : !action.payload.stock <= 0;
      } else {
        // Reset
        localState.countSelected = null;
        localState.stock = null;
        localState.priceBrutto = null;
        localState.shippingTime = null;
        localState.reorderPossible = false;
      }
      break;
    case 'countChange':
      localState.countSelected = action.payload;
      break;
    case 'personalizationChange':
      localState.personalization = action.payload;
      break;
    default:
      console.log('Product Reducer Action Type not found');
      break;
  }
  state = _objectSpread({}, localState);
  return state;
};